window.AA = window.AA || {};

window.AA.initDismissables = () => {
	const elements = [...document.querySelectorAll('[data-aa-dismissable]')];

	elements.length &&
		elements.forEach((el) => {
			if (!el._dismissableInit) {
				el._dismissableInit = true;

				const trigger = el.querySelector('[data-aa-dismissable-trigger]');

				if (trigger) {
					trigger.addEventListener('click', (e) => {
						e.preventDefault();
						el.remove();
					});
				}
			}
		});
};

window.AA.initDismissables();

// Run the script after 3 seconds too, this will be safe as events won't be added twice.
setTimeout(() => {
	window.AA.initDismissables();
}, 3000);
